import * as lookupListActions from '../actions/lookup-list.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface LookupListState {
    listItems: any;
    loading: boolean;
    loaded: boolean;
    error: any;
}

const initialState = {
    listItems: null,
    loading: false,
    loaded: false,
    error: null
};

export const lookupListReducer = (state = initialState, action) => {
    switch(action.type){
        case lookupListActions.GET_LOOKUP_LIST:
            return {
                ...state,
                error: null,
                loading: true,
                loaded: state.loaded
            };
        case lookupListActions.GET_LOOKUP_LIST_SUCCESS:
            return {
                ...state,
                listItems: action.payload,
                error: null,
                loading: false,
                loaded: true
            };
        case lookupListActions.GET_LOOKUP_LIST_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false,
                loaded: false
            };
        default:
            return state;
    }
};

export const getLookupListState = createFeatureSelector<LookupListState>('lookupListReducer');

export const getLookupList = (state: LookupListState) => state.listItems;
export const getLookupListLoaded = (state: LookupListState) => state.loaded;
